import useReveal from "../hooks/useReveal";

/**
 * Reveal — wrap any block to fade-and-rise on scroll.
 * Optional `stagger` prop applies staggered animation to direct children via CSS.
 */
export default function Reveal({
  as: Tag = "div",
  className = "",
  stagger = false,
  threshold = 0.15,
  children,
  ...rest
}) {
  const [ref, visible] = useReveal({ threshold });
  const cls = [
    "reveal",
    stagger ? "stagger" : "",
    visible ? "is-visible" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <Tag ref={ref} className={cls} {...rest}>
      {children}
    </Tag>
  );
}
